import mutations from './moduleListsMutations.js'
import actions from './moduleListsActions.js'
import getters from './moduleListsGetters.js'

const getDefaultState = () => {
  return {
    lastUpdate: 0,
    lists: [],
  }
}

export default {
  isRegistered: false,
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ...mutations,
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions,
  getters
}

